<nav class="main-nav navbar navbar-expand-lg fixed-top" id="mainNav">
  <div class="container nav-container">

    <!-- Brand -->
    <a class="navbar-brand" href="/" (click)="$event.preventDefault(); scrollToTop()">
      <img [src]="logoUrl || 'assets/style-sauvage_only_logo-removebg.png'" class="brand-logo" alt="Logo">
      <span class="brand-name">{{ appTitle }}</span>
    </a>

    <!-- Mobile toggler -->
    <button class="nav-toggler navbar-toggler" type="button"
      data-bs-toggle="collapse" data-bs-target="#navbarResponsive"
      aria-controls="navbarResponsive" aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </button>

    <!-- Collapsible content -->
    <div class="collapse navbar-collapse" id="navbarResponsive">

      <!-- Scroll anchors (centre) -->
      <ul class="navbar-nav nav-links-center">
        <li class="nav-item">
          <a class="nav-link" href="#portfolio"
            (click)="$event.preventDefault(); scrollTo('#portfolio')">
            PORTFOLIO
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#about"
            (click)="$event.preventDefault(); scrollDirect('#about')">
            {{ 'ABOUT' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#contact"
            (click)="$event.preventDefault(); scrollDirect('#contact')">
            CONTACT
          </a>
        </li>
      </ul>

      <!-- Right actions -->
      <div class="nav-actions">

        <!-- Language pills -->
        <div class="lang-pills">
          @for (language of translate.getLangs(); track language) {
            <button class="lang-pill"
              [class.active]="language === translate.currentLang"
              (click)="switchLang(language)">
              {{ language | uppercase }}
            </button>
          }
        </div>

        <!-- Cart -->
        <a class="nav-icon-btn" [routerLink]="['/shopping-cart']"
          (click)="closeMenu()" aria-label="Panier">
          <mat-icon>shopping_cart</mat-icon>
          <ng-container *ngIf="nbSelectedItems$ | async as nb">
            <span class="cart-badge" *ngIf="nb > 0">{{ nb }}</span>
          </ng-container>
        </a>

        <!-- Auth / user actions -->
        @if (user$ | async; as user) {
          <!-- History -->
          <a class="nav-icon-btn" [routerLink]="['/order-history']"
            (click)="closeMenu()" aria-label="Historique commandes">
            <mat-icon>history</mat-icon>
          </a>

          <!-- Avatar with email popup -->
          @if (user.photoURL) {
            <div class="avatar-wrapper" (click)="$event.stopPropagation(); toggleEmail()">
              <img class="user-avatar" [src]="user.photoURL" alt="avatar" loading="lazy">
              <div class="avatar-email-popup" [class.visible]="showEmail">{{ user.email }}</div>
            </div>
          }

          <!-- Disconnect -->
          <button class="nav-icon-btn" (click)="disconnect()"
            [title]="'DISCONNECT' | translate" aria-label="Déconnexion">
            <mat-icon>logout</mat-icon>
          </button>

        } @else {
          <!-- Connect -->
          <a class="nav-icon-btn" [routerLink]="['/auth/signin']"
            (click)="closeMenu()" aria-label="Connexion">
            <mat-icon>account_circle</mat-icon>
          </a>
        }

      </div>
    </div>

  </div>
</nav>
